import { useCallback, useEffect, useRef, useState } from 'react';

export default function useFullscreenGuard({ requireFullscreen, active, disqualified, registerViolation }) {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const fullscreenRequestRef = useRef(false);
  const hasEverEnteredFullscreenRef = useRef(false);

  const enterFullscreen = useCallback(async () => {
    try {
      fullscreenRequestRef.current = true;
      const el = document.documentElement;
      if (el.requestFullscreen) await el.requestFullscreen();
      else if (el.webkitRequestFullscreen) await el.webkitRequestFullscreen();
      else if (el.mozRequestFullScreen) await el.mozRequestFullScreen();
      setIsFullscreen(true);
      hasEverEnteredFullscreenRef.current = true;
      setTimeout(() => { fullscreenRequestRef.current = false; }, 2000);
    } catch (err) {
      console.error('Fullscreen error:', err);
      fullscreenRequestRef.current = false;
    }
  }, []);

  useEffect(() => {
    if (!requireFullscreen) { setIsFullscreen(true); return undefined; }

    const checkFullscreen = () => {
      const isFull = !!document.fullscreenElement || !!document.webkitFullscreenElement || !!document.mozFullScreenElement;
      setIsFullscreen(isFull);

      if (isFull) {
        hasEverEnteredFullscreenRef.current = true;
        fullscreenRequestRef.current = false;
        return;
      }
      if (!hasEverEnteredFullscreenRef.current) return;
      if (fullscreenRequestRef.current) return;

      if (active && !disqualified) {
        registerViolation('fullscreen_exit', 'Keluar dari mode fullscreen saat tes berlangsung.');
      }
    };

    document.addEventListener('fullscreenchange', checkFullscreen);
    document.addEventListener('webkitfullscreenchange', checkFullscreen);
    document.addEventListener('mozfullscreenchange', checkFullscreen);
    return () => {
      document.removeEventListener('fullscreenchange', checkFullscreen);
      document.removeEventListener('webkitfullscreenchange', checkFullscreen);
      document.removeEventListener('mozfullscreenchange', checkFullscreen);
    };
  }, [requireFullscreen, active, disqualified, registerViolation]);

  return { isFullscreen, enterFullscreen, fullscreenRequestRef };
}